import cardActionAreaClasses from "@mui/material/CardActionArea/cardActionAreaClasses";
export const MuiCardActionAreaTheme = (dt) => {
    return {
        defaultProps: {
            disableRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                hasPixelTheme: "true",
                display: "flex",
                alignItems: "normal",
                flexDirection: "column",
                flexGrow: 1,
                justifyContent: "flex-start",
                borderRadius: dt.borderRadius.medium,
                [`.${cardActionAreaClasses.focusHighlight}`]: {
                    zIndex: 1,
                },
                "&:hover:not(:has(:where(button:hover, a:hover)))": {
                    [`.${cardActionAreaClasses.focusHighlight}`]: {
                        opacity: 1,
                        border: `${dt.borderWidth.small} solid ${dt.color.primary.key}`,
                    },
                },
                "&:active:not(:has(:where(button:hover, a:hover)))": {
                    [`.${cardActionAreaClasses.focusHighlight}`]: {
                        opacity: 1,
                        border: `${dt.borderWidth.medium} solid ${dt.color.primary.key}`,
                    },
                },
            },
            focusHighlight: {
                background: "transparent",
            },
        },
    };
};
